<template>
    <div>
        <div :class="['text-subtitle-1', disabled ? 'text-disabled' : 'text-medium-emphasis']">
            {{ label }}
            <span v-if="infoText"><FieldInfoIcon :infotext="infoText"></FieldInfoIcon></span>
        </div>
    </div>
</template>

<script setup lang="ts">
import FieldInfoIcon from '@/components/field-info-icon.vue'

const {
    label = '',
    infoText = null,
    disabled = false,
} = defineProps<{
    label: string
    infoText?: string | null
    disabled?: boolean
}>()
</script>
